<div class="flex justify-center mt-8">
  <div
    class="flex flex-wrap items-center justify-center w-full md:flex-row flex-col-reverse lg:flex-nowrap"
  >
    <div
      class="relative contents lg:flex mb-4 mr-3 text-center md:basis-1/2 lg:text-right ml-24"
    >
      <div>
        <div class="font-bold mt-2 mb-3 mx-7 sm:mx-0">
          <span class="inline sm:hidden text-lg">
            جدیدترین اخبار و رویدادها در ایرانی اکسپرت
          </span>
          <span class="hidden sm:inline sm:text-2xl">
            جدیدترین اخبار و رویدادها را در ایرانی اکسپرت دنبال کنید
          </span>
        </div>
        
        <p class="font-normal mt-2 mx-7 sm:mx-0">
          <span class="inline sm:hidden">
            آپدیت‌ها، اطلاع‌رسانی و کمپین‌ها در اینستا و روبیکا
          </span>
          <span class="hidden sm:inline sm:text-base">
            آپدیت‌های ربات، اطلاع‌رسانی‌ها، کمپین‌ها و قرعه‌کشی‌ها در صفحه اینستاگرام و روبیکا ایرانی اکسپرت
          </span>
        </p>
      </div>
    </div>
    <!-- ===============[بنر اینستا]========== -->
    <div class="relative w-full md:basis-1/2 mt-8 lg:mt-0">
      <div class="flex flex-row ins-baner sm:p-4 p-1 mx-2">
        <div class="flex basis-1/4 items-center text-center">
          <div class="sm:text-base  ins-desc lg">
            پروفایل آموزشی ایرانی اکسپرت
          </div>
        </div>
        <div class="flex items-center justify-center text-center basis-2/4">
          <a
          href="https://www.instagram.com/IRani_Expert/"
          class="link-ins text-sm px-0 py-2 bg-white mr-4 font-semibold flex min-w-[75%] justify-center"
        >
          <span class="inline sm:hidden">
            اینستاگرام
          </span>
          <span class="hidden sm:inline">
            بهترین پیج فارکس در اینستاگرام
          </span>
        </a>
        </div>
        <div class="relative flex justify-center items-center basis-1/4">
          <img
            class="logo-ins absolute w-20"
            src="assets/img/logo-ins.webp"
            alt="لینک به اینستاگرام ایرانی اکسپرت"
            width="80"
            height="80"
            loading="lazy"
          />
        </div>
      </div>
    </div>
  </div>
</div>
